import React from 'react';
import { DownloadIcon, ShoppingCartIcon, TrendingDownIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <DownloadIcon className="w-8 h-8 text-white" data-id="element-67" />,
    title: 'Descargas la Guía',
    desc: 'Recibes el acceso inmediato a tu PDF en el correo.'
  }, {
    icon: <ShoppingCartIcon className="w-8 h-8 text-white" data-id="element-68" />,
    title: 'Haces el Mercado',
    desc: 'Sigues la lista de compras optimizada para ahorro en Colombia.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-white" data-id="element-69" />,
    title: 'Ves los Resultados',
    desc: 'Sigues el menú por 7 días y sientes cómo tu ropa empieza a quedar suelta.'
  }];
  return <section className="bg-[#FAFAF5] text-[#1A1A1A] py-16 md:py-24 px-4" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <div className="text-center mb-16" data-id="element-72">
          <h2 className="font-montserrat font-black text-4xl md:text-5xl mb-4 uppercase" data-id="element-73">
            ¿Cómo funciona?
          </h2>
          <p className="font-inter text-xl text-gray-600" data-id="element-74">
            3 pasos simples para empezar hoy mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-75">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gray-200 z-0" data-id="element-76"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-77">
              <div className="w-24 h-24 bg-[#1A1A1A] rounded-full flex items-center justify-center mb-6 shadow-xl border-4 border-[#FAFAF5]" data-id="element-78">
                {step.icon}
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 w-full h-full" data-id="element-79">
                <div className="text-[#F5C518] font-montserrat font-black text-xl mb-2" data-id="element-80">
                  PASO {index + 1}
                </div>
                <h3 className="font-montserrat font-bold text-2xl mb-3 text-[#1A1A1A]" data-id="element-81">
                  {step.title}
                </h3>
                <p className="font-inter text-gray-600 leading-relaxed" data-id="element-82">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}